import { useEffect, useRef, useState } from 'react';
import { clientAllocate, EXPERIMENT_TYPE } from '@fiverr-private/experiments';
import { useEnteredView } from '@fiverr-private/hooks';
import { DOLPHINS_LOHP_PRO_PACKAGES } from '../../utils/experiments/experimentsEnum';

interface ProPackagesBannerExperiment {
    experimentVariant: number | null;
    showBanner: boolean;
    observableRef: React.RefObject<HTMLDivElement>;
}

const useProPackagesBannerExperiment = (inProPackagesBanner: boolean): ProPackagesBannerExperiment => {
    const [experimentVariant, setExperimentVariant] = useState<number | null>(null);
    const [isIntersecting, setIsIntersecting] = useState(false);
    const [showBanner, setShowBanner] = useState(false);
    const observableRef = useRef<HTMLDivElement>(null);

    useEnteredView(observableRef, {
        threshold: 0,
        onEntered: () => setIsIntersecting(true),
    });

    useEffect(() => {
        if (isIntersecting) {
            const variant =
                clientAllocate({
                    experimentType: EXPERIMENT_TYPE.GUEST,
                    experimentId: DOLPHINS_LOHP_PRO_PACKAGES,
                    numOfGroups: 2,
                    rolloutResult: inProPackagesBanner,
                }) ?? null;

            setExperimentVariant(variant);
            setShowBanner(true);
        }
    }, [isIntersecting, inProPackagesBanner]);

    return { experimentVariant, showBanner, observableRef };
};

export default useProPackagesBannerExperiment;
